import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { authSelector } from 'redux/auth/selectors';
import { getQsServer, getPublicQsServer } from 'redux/actions/qsServerActions';
import QlikWebSocketService from 'websockets/service/QlikWebSocketService';
import Loading from 'components/common/Loading';
import QlikSaaSService from 'websockets/service/QlikSaaSService';
import { qlikClient } from 'constants/environmental';
import config from 'coeus.config';

const SAAS = config.saas_client === qlikClient.SAAS;
const socketService = SAAS ? new QlikSaaSService() : new QlikWebSocketService();

const Root = ({ children }) => {
    const dispatch = useDispatch();
    const { isAuthenticated, user } = useSelector(authSelector);
    const { publicAccess } = useSelector((state) => state.settings);

    const { qsServer } = useSelector((state) => state.qsServer);
    const isLoading = useSelector(
        (state) => state.auth.loading || state.qsServer.loading
    );

    const getServerDetails = () => {
        if (!qsServer) {
            if (isAuthenticated && !publicAccess) {
                dispatch(getQsServer());
            } else {
                dispatch(getPublicQsServer());
            }
        }
    };

    useEffect(() => {
        if (!isLoading) {
            getServerDetails();
        }
    }, [isAuthenticated, qsServer, publicAccess]);


    useEffect(() => {
        return () => {
            socketService.closeAllSockets();
        };
    }, []);

    if (isLoading) {
        return <Loading />;
    }

    return <div>{children}</div>;
};

Root.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
        PropTypes.element,
    ]),
};

export default Root;
